import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    noticeManagementListLoading: false,
    noticeManagementListSuccess: null,
    noticeManagementListError: '',
    // documentsListLoading: false,
    // documentsListSuccess: null,
    // documentsListError: '',
    getNoticeLoading: false,
    getNoticeSuccess: {},
    getNoticeError: '',
    studyContentListLoading: false,
    studyContentListSuccess: null,
    studyContentListError: '',
    getStudycontentLoading: false,
    getStudycontentSuccess: {},
    getStudycontentError: ''
}

export const noticeManageSlice = createSlice({
    name: 'notice-management',
    initialState,
    reducers: {
        setNoticeManagementListLoading: (state, action) => {
            state.noticeManagementListLoading = true;
            state.noticeManagementListSuccess = null;
            state.noticeManagementListError = '';
        },
        setNoticeManagementListSuccess: (state, action) => {
            state.noticeManagementListLoading = false;
            state.noticeManagementListSuccess = action.payload;
            state.noticeManagementListError = '';
        },
        setNoticeManagementListError: (state, action) => {
            state.noticeManagementListLoading = false;
            state.noticeManagementListSuccess = null;
            state.noticeManagementListError = action.payload;
        },
        // setDocumentsListLoading: (state, action) => {
        //     state.documentsListLoading = true;
        //     state.documentsListSuccess = null;
        //     state.documentsListError = '';
        // },
        // setDocumentsListSuccess: (state, action) => {
        //     state.documentsListLoading = false;
        //     state.documentsListSuccess = action.payload;
        //     state.documentsListError = '';
        // },
        // setDocumentsListError: (state, action) => {
        //     state.documentsListLoading = false;
        //     state.documentsListSuccess = null;
        //     state.documentsListError = action.payload;
        // },
        setGetNoticeLoading: (state) => {
            state.getNoticeLoading = true;
            state.getNoticeSuccess = {};
            state.getNoticeError = '';
        },
        setGetNoticeSuccess: (state, action) => {
            state.getNoticeLoading = false;
            state.getNoticeSuccess = action.payload;
            state.getNoticeError = '';
        },
        setGetNoticeError: (state, action) => {
            state.getNoticeLoading = false;
            state.getNoticeSuccess = {};
            state.getNoticeError = action.payload;
        },
        resetDetails: (state, action) => {
            state.getNoticeSuccess = {};
        },
        setStudyContentListLoading: (state, action) => {
            state.studyContentListLoading = true;
            state.studyContentListSuccess = null;
            state.studyContentListError = '';
        },
        setStudyContentListSuccess: (state, action) => {
            state.studyContentListLoading = false;
            state.studyContentListSuccess = action.payload;
            state.studyContentListError = '';
        },
        setStudyContentListError: (state, action) => {
            state.studyContentListLoading = false;
            state.studyContentListSuccess = null;
            state.studyContentListError = action.payload;
        },

        getStudyContentLoading: (state) => {
            state.getStudycontentLoading = true;
            state.getStudycontentSuccess = {};
            state.getStudycontentError = '';
        },
        getStudyContentSuccess: (state, action) => {
            state.getStudycontentLoading = false;
            state.getStudycontentSuccess = action.payload;
            state.getStudycontentError = '';
        },
        getStudyContentError: (state, action) => {
            state.getStudycontentLoading = false;
            state.getStudycontentSuccess = {};
            state.getStudycontentError = action.payload;
        },
        resetStudyContent: (state, action) => {
            state.getStudycontentSuccess = {};
        },
    },
})

export const {
    setNoticeManagementListLoading, setNoticeManagementListSuccess, setNoticeManagementListError,
    // setDocumentsListLoading, setDocumentsListSuccess, setDocumentsListError,
    setGetNoticeLoading, setGetNoticeSuccess, setGetNoticeError,
    resetDetails,
    setStudyContentListLoading, setStudyContentListSuccess, setStudyContentListError, getStudyContentLoading, getStudyContentError, getStudyContentSuccess
} = noticeManageSlice.actions

export default noticeManageSlice.reducer;